"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _reactUse = require("react-use");

var _reactRedux = require("react-redux");

var _marketplace = require("../../store/marketplace/marketplace.actions");

var _marketplace2 = require("../../store/marketplace/marketplace.selector");

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    headerWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      width: '100%',
      borderTop: "1px solid ".concat(palette.dividerLight)
    }
  };
});

var ProductPriceInput = function ProductPriceInput(_ref2) {
  var _product$giftCardRang, _product$giftCardRang2, _product$giftCardRang6, _product$giftCardRang7, _product$giftCardRang8, _product$giftCardRang9, _product$giftCardRang10;

  var product = _ref2.product,
      error = _ref2.error,
      setError = _ref2.setError;
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var convertedPrice = (0, _reactRedux.useSelector)(_marketplace2.getMarketplaceConvertedPrice);
  var isLoading = (0, _reactRedux.useSelector)(_marketplace2.getMarketplaceExchangeIsLoading);
  var minValue = (product === null || product === void 0 ? void 0 : (_product$giftCardRang = product.giftCardRange) === null || _product$giftCardRang === void 0 ? void 0 : _product$giftCardRang.minPrice) || 0;
  var maxValue = (product === null || product === void 0 ? void 0 : (_product$giftCardRang2 = product.giftCardRange) === null || _product$giftCardRang2 === void 0 ? void 0 : _product$giftCardRang2.maxPrice) || 0;

  var _useState = (0, _react.useState)(minValue),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      localValue = _useState2[0],
      setLocalValue = _useState2[1];

  var validate = (0, _react.useCallback)(function (value) {
    if (value < minValue || value > maxValue) {
      setError({
        denomination: ["Should be between ".concat(minValue, " and ").concat(maxValue)]
      });
      return false;
    }

    if (value % 5 !== 0) {
      setError({
        denomination: ['Should be a multiple of 5']
      });
      return false;
    }

    return true;
  }, [maxValue, minValue, setError]);
  (0, _reactUse.useDebounce)(function () {
    setError(undefined);

    if (localValue && validate(localValue)) {
      var _product$giftCardRang3;

      dispatch((0, _marketplace.setValueRangedProduct)(localValue));

      if ((product === null || product === void 0 ? void 0 : (_product$giftCardRang3 = product.giftCardRange) === null || _product$giftCardRang3 === void 0 ? void 0 : _product$giftCardRang3.currencyId) !== 1) {
        var _product$giftCardRang4;

        dispatch((0, _marketplace.loadExchangeRateRequest)({
          fromCurrency: product === null || product === void 0 ? void 0 : (_product$giftCardRang4 = product.giftCardRange) === null || _product$giftCardRang4 === void 0 ? void 0 : _product$giftCardRang4.currencyId,
          toCurrency: 1,
          value: localValue
        }));
      }
    }
  }, 500, [localValue, validate, dispatch]);
  var endAdornment = (0, _react.useMemo)(function () {
    var _product$giftCardRang5;

    if (!localValue || (product === null || product === void 0 ? void 0 : (_product$giftCardRang5 = product.giftCardRange) === null || _product$giftCardRang5 === void 0 ? void 0 : _product$giftCardRang5.currencyId) === 1) {
      return null;
    }

    return isLoading ? /*#__PURE__*/_react.default.createElement(_ui.LoadingLabel, {
      width: 28
    }) : /*#__PURE__*/_react.default.createElement(_material.InputAdornment, {
      position: "end"
    }, "$", convertedPrice);
  }, [localValue, isLoading, convertedPrice, product]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.headerWrapper
  }, /*#__PURE__*/_react.default.createElement(_ui.NumberField, {
    name: "denomination",
    fullWidth: true,
    max: product === null || product === void 0 ? void 0 : (_product$giftCardRang6 = product.giftCardRange) === null || _product$giftCardRang6 === void 0 ? void 0 : _product$giftCardRang6.maxPrice,
    min: product === null || product === void 0 ? void 0 : (_product$giftCardRang7 = product.giftCardRange) === null || _product$giftCardRang7 === void 0 ? void 0 : _product$giftCardRang7.minPrice,
    step: 5,
    error: !!error,
    errors: error,
    value: localValue,
    placeholder: "".concat(product === null || product === void 0 ? void 0 : (_product$giftCardRang8 = product.giftCardRange) === null || _product$giftCardRang8 === void 0 ? void 0 : _product$giftCardRang8.minPrice, " - ").concat(product === null || product === void 0 ? void 0 : (_product$giftCardRang9 = product.giftCardRange) === null || _product$giftCardRang9 === void 0 ? void 0 : _product$giftCardRang9.maxPrice),
    InputProps: {
      startAdornment: /*#__PURE__*/_react.default.createElement(_material.InputAdornment, {
        position: "start"
      }, product === null || product === void 0 ? void 0 : (_product$giftCardRang10 = product.giftCardRange) === null || _product$giftCardRang10 === void 0 ? void 0 : _product$giftCardRang10.currencySign),
      endAdornment
    },
    required: true,
    variant: "outlined",
    onChange: function onChange(newValue) {
      return setLocalValue(parseInt(newValue.toString(), 10));
    }
  }));
};

var _default = /*#__PURE__*/(0, _react.memo)(ProductPriceInput);

exports.default = _default;